import { cancelOrderForCes, saveBusinessContractInfo } from '@/API/international';
import { getLoginUser } from '@/API';
import { buildIntlBusinessApprovalComplianceRequest, checkIntlExportCompliance } from '@/libs/exportCompliance';
export default {
  methods: {
    // 1 未审核 2 已审核 0 驳回
    async handleSubmit (approvalDecide) {
      // 审批意见
      let approvalComments = this.$refs.approvalComments;
      // 驳回，验证审批意见
      if (approvalDecide === 0) {
        if (!await approvalComments.validate()) {
          return false;
        }
      } else {
        // 验证基本信息必填项
        if (!await this.$refs.baseInfo.validate()) {
          return false;
        }
      }
      if (approvalDecide === 0 && this.form.contractType === '国际分销下单') {
        this.loading = true;
        let params = {
          id: this.form.id,
          orderUnitPhone: this.form.orderUnitPhone,
          businessApproval: approvalDecide,
          approvaLog: approvalComments.rejectedForm.rejectedInfo,
          shipType: this.form.shipType // 分批发货字段: 0-齐套 1- 分批
        };
        this.loading = true;
        saveBusinessContractInfo(params).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            getLoginUser().then(({ data: { status, data } }) => {
              if (Number(status) === 200) {
                const params = {
                  orderId: this.form.smeFromId,
                  createUserId: data.userId,
                  createUserName: data.userName,
                  approveStep: 'CesStepName_5',
                  remark: this.$refs.approvalComments.rejectedForm.rejectedInfo
                };
                cancelOrderForCes(params).then(({ status, data }) => {
                  if (Number(status) === 200) {
                    console.log(data);
                    this.loading = false;
                    this.$router.replace({
                      name: 'businessContractList'
                    });
                  }
                }).catch(() => {
                  this.loading = false;
                });
              }
            }).catch(() => {
              this.loading = false;
            });
          }
        }).catch(() => {
          this.loading = false;
        });
      } else {
        if (approvalDecide === 2) {
          this.loading = true;
          const decision = await checkIntlExportCompliance(this,
            buildIntlBusinessApprovalComplianceRequest(this.form,
              (this.$refs.product && this.$refs.product.productList) || []));
          if (!decision.allowBusiness) {
            this.loading = false;
            return false;
          }
        }
        this.loading = true;
        let params = {
          id: this.form.id,
          orderUnitPhone: this.form.orderUnitPhone,
          businessApproval: approvalDecide,
          approvaLog: approvalComments.rejectedForm.rejectedInfo,
          shipType: this.form.shipType // 分批发货字段: 0-齐套 1- 分批
        };
        this.loading = true;
        saveBusinessContractInfo(params).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            this.$router.replace({
              name: 'businessContractList'
            });
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    }
  }
};
